export const RULES_PATH = '/rules';
